import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'


//上传图片
export function uploadFile(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/file/upload`,
        method: 'post',
        data
    })
}

//上传删除
export function uploadRemove(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/file/remove`,
        method: 'post',
        data
    })
}

export function uploadFileInfo(file, type) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("type", type);
    return request({
        url: `/${systemConfig.sysPrefix}/sys/file/upload`,
        method: 'post',
        data: formData,
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    })
}

export function uploadChunk(file, chunk, chunks, md5) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("chunk", chunk);
    formData.append("chunks", chunks);
    formData.append("md5", md5);
    return request({
        url: `/${systemConfig.sysPrefix}/sys/file/uploadChunk`,
        method: 'post',
        timeout: 20 * 1000,
        data: formData,
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    })
}

export function mergeChunk(md5, size, contentType, chunks, filename) {
    let formData = new FormData();
    formData.append("md5", md5);
    formData.append("size", size);
    formData.append("contentType", contentType);
    formData.append("chunks", chunks);
    formData.append("filename", filename);
    return request({
        url: `/${systemConfig.sysPrefix}/sys/file/mergeChunk`,
        method: 'post',
        data: formData,
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    })
}

export function deleteChunks(md5) {
    let formData = new FormData();
    formData.append("md5", md5);
    return request({
        url: `/${systemConfig.sysPrefix}/sys/file/deleteChunks`,
        method: 'post',
        data: formData,
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    })
}

export function deleteFile(md5) {
    let formData = new FormData();
    formData.append("md5", md5);
    return request({
        url: `/${systemConfig.sysPrefix}/sys/file/deleteFile`,
        method: 'post',
        data: formData,
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    })
}

export function downloadTemplateinfo(url) {
    return request({
        url: `${systemConfig.unpaidWagesPrefix}${url}`,
        method: 'post',
        responseType: 'blob'
    })
}

